import classNames from 'classnames';

import styles from './PreloaderCloud.module.scss';
import { PreloaderCloudProps } from './PreloaderCloud.types';

export function PreloaderCloud({ active }: PreloaderCloudProps) {
  return (
    <div
      className={classNames(styles.preloader, {
        [styles.active]: active,
      })}
    >
      <svg
        width="96"
        height="96"
        viewBox="0 0 96 96"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          className={styles.box}
          d="M0,45.6393 C0,24.12474 0,13.36746 6.68373,6.68373 C13.36746,0 24.12474,0 45.6393,0 L50.3607,0 C71.8752,0 82.6326,0 89.3163,6.68373 C96,13.36746 96,24.12474 96,45.6393 L96,50.3607 C96,71.8752 96,82.6326 89.3163,89.3163 C82.6326,96 71.8752,96 50.3607,96 L45.6393,96 C24.12474,96 13.36746,96 6.68373,89.3163 C0,82.6326 0,71.8752 0,50.3607 L0,45.6393 Z"
        />
        <path
          className={styles.cube}
          d="M21.23619,0.753615 C27.36231,0 35.2455,0 45.6393,0 L50.3607,0 C60.7545,0 68.6376,0 74.7639,0.753618 C75.1614,1.349382 75.36,1.939815 75.36,2.55831 C75.36,5.22027 71.6787,7.36248 64.3164,11.64684 L63.6177,12.05343 C56.2554,16.33779 52.5744,18.48 48,18.48 C43.4256,18.48 39.7446,16.33782 32.3823,12.05343 L31.6836,11.64684 C24.32115,7.36248 20.64,5.22027 20.64,2.558313 C20.64,1.939818 20.83872,1.349382 21.23619,0.753615 Z"
        />
        <path
          className={styles.cube}
          d="M27.06297,20.28831 C34.5093,24.58752 38.2326,26.73714 40.5459,30.744 C42.8592,34.7508 42.8592,39.0498 42.8592,47.6484 L42.8592,48.4644 C42.8592,57.0627 42.8592,61.362 40.5459,62.6976 C38.2326,64.0332 34.5093,61.8834 27.06297,57.5844 L26.35632,57.1764 C18.90987,52.8771 15.18663,50.7276 12.8733,46.7208 C10.56,42.714 10.56,38.4147 10.56,29.81631 L10.56,29.00034 C10.56,20.40192 10.56,16.10271 12.87333,14.76711 C15.18663,13.43151 18.90987,15.5811 26.35632,19.88031 L27.06297,20.28831 Z"
        />
        <path
          className={styles.cube}
          d="M68.937,20.73435 C61.4907,25.03356 57.7674,27.18315 55.4541,31.1898 C53.1408,35.1966 53.1408,39.4959 53.1408,48.0942 L53.1408,48.9102 C53.1408,57.5088 53.1408,61.8081 55.4541,63.1437 C57.7674,64.4793 61.4907,62.3295 68.937,58.0302 L69.6438,57.6225 C77.0901,53.3232 80.8134,51.1734 83.1267,47.1666 C85.44,43.1601 85.44,38.8608 85.44,30.2622 L85.44,29.44635 C85.44,20.84793 85.44,16.54872 83.1267,15.21312 C80.8134,13.87752 77.0901,16.02714 69.6438,20.32635 L68.937,20.73435 Z"
        />
      </svg>
    </div>
  );
}
